import React, { useCallback, useContext } from "react";
import styles from "./index.module.scss";

import { Button } from "antd";
import classNames from "classnames";
import ItemStatus from "./components/ItemStatus";
import Spacer from "components/Spacer";
import { SourceType } from "API/courseware";
import FileIcon from "../../../../../CourseDetail/Courseware/components/FileIcon";
import { ChapterContext } from "../../../../store";
import { isTrue } from "Utils/filter";

interface CoursewareItemProps {
    data: SourceType;
    indent: number;
    style?: React.CSSProperties;
}

export default function CoursewareItem({ data, indent }: CoursewareItemProps) {
    const { onViewCourseware } = useContext(ChapterContext);

    const handleClick = useCallback(() => {
        onViewCourseware(data.id);
    }, [data.id, onViewCourseware]);

    return (
        <div
            role="button"
            className={styles.root}
            style={{ paddingLeft: 30 * indent }}>
            <div className={classNames(styles.icon)}>
                <FileIcon ext={data.sourceFileEntity?.fileType || ""} />
            </div>

            <div className={styles.main}>
                <h1 className={styles.title}>
                    {data.sourceFileEntity?.fileName}{" "}
                    <ItemStatus
                        status={
                            isTrue(data.studyStatusEntity?.studyStatus)
                                ? "done"
                                : "todo"
                        }
                    />
                </h1>
                <div className={styles.info}>
                    <span>{isTrue(data.isDownload) ? "允许" : "禁止"}下载</span>
                    <span>大小 {data.sourceFileEntity?.fileSize}</span>
                </div>
            </div>

            <Spacer />

            <div className={styles.buttons}>
                <Button
                    type="link"
                    className={styles.button}
                    onClick={handleClick}>
                    前往学习{/*学习回顾*/}
                </Button>
            </div>
        </div>
    );
}
